__turbopack_context__.v({
  "goToLast": "Pagination-module-scss-module__tiWajW__goToLast",
  "iconButton": "Pagination-module-scss-module__tiWajW__iconButton",
  "iconDisabled": "Pagination-module-scss-module__tiWajW__iconDisabled",
  "iconEnabled": "Pagination-module-scss-module__tiWajW__iconEnabled",
  "pageInput": "Pagination-module-scss-module__tiWajW__pageInput",
});
